import styled from 'styled-components';
import { newColors } from '~/themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
export const Wrapper = styled.div `
  background: ${newColors.snow};
  display: flex;
  flex-direction: row;
  width: inherit;
  height: 100%;
  padding: 49px;
  ${mediaq.sm `
  flex-direction: column;
  padding: 24px 0;
  width: auto;
  `}
`;
export const Column = styled.div `
  flex: 0.8;
  padding: 18px;
  ${mediaq.sm `
  padding: 10px 18px;
  `}
  &:not(:first-child) {
    border-left: 1px solid ${newColors.gray100};
    ${mediaq.sm `
      border-left: 0px;
    `}
  }
  &:nth-of-type(even) {
    flex: 2;
  }
`;
export const Header = styled.div `
  font-family: 'Inria Serif';
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: ${newColors.gray800};
  text-align: ${(props) => (props.twoColumn ? 'left' : 'center')};
  padding-bottom: ${(props) => (props.twoColumn ? '20px' : '0px')};
  ${mediaq.sm `
  text-align: left;
  `}
`;
export const VenueContainer = styled.div `
  padding: ${(props) => (props.twoColumn ? '0px' : '0px 55px;')};
  display: flex;
  flex-direction: row;
  width: 100%;
  ${mediaq.sm `
  flex-direction: column;
  padding: 0;
  `}
`;
export const VenueDetails = styled.div `
  display: flex;
  flex-direction: row;
  flex: 1;
  &:nth-of-type(odd) {
    text-align: left;
    flex: 1;
  }
  &:nth-of-type(even) {
    flex: 1;
    text-align: right;
    margin-top: auto;
    ${mediaq.lg `
    margin-top: 20px;
    text-align: left;
    `}
  }
  p {
    font-family: 'Inter Variable', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: ${newColors.gray800};
    margin-bottom: 8px;
    svg {
      margin-right: 4px;
    }
    a {
      color: ${newColors.purple800};
      &:hover,
      &:active {
        color: ${newColors.purple500};
      }
    }
  }
`;
export const VenueDetailColumn = styled.div `
  flex: 1;
`;
export const VenueDetailLogoColumn = styled.div `
  display: flex;
  padding-bottom: 15px;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  ${mediaq.lg `
  display: none;
  `}
`;
export const VenueName = styled.div `
  font-family: 'Inter Variable', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: ${newColors.gray800};
  ${mediaq.sm `
  padding-bottom: 0px;
  `}
`;
export const VenueAddress = styled.div `
  font-family: 'Inter Variable', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  color: ${newColors.gray800};
  padding-bottom: 20px;
`;
export const VenueLogoWrapper = styled.div `
  padding-top: 20px;
  display: none;
  ${mediaq.lg `
  display: block;
  `}
`;
